module.exports = __webpack_public_path__ + "static/img/img-22.5e47c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-22.jpg
// module id = HvTL
// module chunks = 1